import { Component, OnInit } from '@angular/core';
import { AuthSelectors, SessionSelectors, TimetrackDispatchers, TimetrackSelectors } from '@store';
import { combineLatest } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Component({
    selector: 'app-employees-done',
    template: `
        <app-employees-done-ui
            [usersWithDone]="usersWithDone$ | async"
            [year]="year$ | async"
            [week]="week$ | async"
            [today]="today$ | async"
            [lev]="lev$ | async"
            (reopen)="deleteUgerepDone($event)"
        ></app-employees-done-ui>
    `,
    standalone: false
})
export class EmployeesDoneContainerComponent implements OnInit {

    year$ = this.timetrackSelector.year$;
    week$ = this.timetrackSelector.week$;
    today$ = this.timetrackSelector.today$;
    lev$ = this.authSelector.userLev$;
    usersWithDone$ = combineLatest([
        this.year$.pipe(
            switchMap(year => this.sessionSelector.usersSA$(new Date(year, 0, 1)))
        ),
        this.timetrackSelector.officeUgerepDoneWeek$
    ]).pipe(
        map(([users, dones]) => users.map(user => ({
                ...user,
                doneDag1: dones.doneDag1.find(d => d.mid === user.cardId),
                doneDag2: dones.doneDag2.find(d => d.mid === user.cardId),
                doneDag3: dones.doneDag3.find(d => d.mid === user.cardId),
                doneDag4: dones.doneDag4.find(d => d.mid === user.cardId),
                doneDag5: dones.doneDag5.find(d => d.mid === user.cardId),
                doneDag6: dones.doneDag6.find(d => d.mid === user.cardId),
                doneDag7: dones.doneDag7.find(d => d.mid === user.cardId)
            }))
        )
    );

    constructor(
        private sessionSelector: SessionSelectors,
        private timetrackSelector: TimetrackSelectors,
        private timetrackDispatch: TimetrackDispatchers,
        private authSelector: AuthSelectors
    ) { }

    ngOnInit(): void {
        this.timetrackDispatch.loadOfficeUgerepDone();
    }

    deleteUgerepDone(id: number) {
        this.timetrackDispatch.deleteUgerepDone(id);
    }

}
